<template>
  <fragment>
    <span>
      <b-icon :icon="icon" :variant="iconVariant"></b-icon>
      {{ getStatusLabel() }}
    </span>
  </fragment>
</template>
<script>
export default {
  props: {
    status: {
      type: String,
    },
    daysToExpired: {
      type: Number,
    }
  },
  data() {
    return {
      icon: "circle-fill",          //Default icon (no predefined match)
      iconVariant: "primary",       //Default icon variant
    }
  },
  mounted() {
    this.setIcon();
  },
  watch: {
    //If status prop changes, update the icon
    status: {
      immediate: true,
      deep: true,
      handler() {
        this.setIcon();
      }
    }  
  },     
  methods: {
    getStatusLabel() {
      let label = "";
      switch(this.status) {
        case "pending":
          label = this.daysToExpired + " " + this.$t("quote.status.pending");
          break;
        default:
          if (this.$t("quote.status." + this.status)) {
            label = this.$t("quote.status." + this.status);
          }
          break;
      }

      return label;
    },
    setIcon() {
      switch(this.status.toLowerCase()) {
        case "open":
          this.icon = "plus-circle-fill";
          this.iconVariant = "primary";
          break;
        case "pending":
          this.icon = "exclamation-circle-fill";
          this.iconVariant = "warning";
          break;
        case "expired":
        case "lost":
        case "invalid":
        case "declined":
          this.icon = "dash-circle-fill";
          this.iconVariant = "danger";
          break;
        case "won":
          this.icon = "check-circle-fill";
          this.iconVariant = "success";
          break;
        case "repwon":
          this.icon = "check-circle-fill";
          this.iconVariant = "warning";
          break;
        case "quoted":
          this.icon = "check-circle-fill";
          this.iconVariant = "info";
          break;
        default:
          break;
      }
    },    
  }
}
</script>
